/* eslint-disable import/no-cycle */
import { fork, all } from 'redux-saga/effects';

import watchWorkHoursExport from './workHoursExportSaga';
import watchImportUsers from './importUsersSaga';
import watchUserInfo from './employeesSaga';
import watchLaw from './lawSaga';
import watchLawChecks from './lawChecksSaga';
import watchConfirmWorkHours from './confirmWorkHoursReportSaga';
import workTimeTypesSaga from './WorkTimeTypesSaga';
import watchConfirmators from './confirmatorsAdministrationSaga';

export default function* rootSaga() {
  yield all([
    fork(watchLaw),
    fork(watchWorkHoursExport),
    fork(watchImportUsers),
    fork(watchUserInfo),
    fork(watchLawChecks),
    fork(watchConfirmWorkHours),
    fork(workTimeTypesSaga),
    fork(watchConfirmators)
  ]);
}
